import FieldProto from "../../../proto/field-proto";
import FieldConfig from "../../../proto/field-config";
import FieldProjects_View from "./render/views";
import FieldProjects_InlineEditable from "./render/inline-editable";
import FieldProjects_AutomationTriggerForm from "./render/automation-trigger-form";
import FieldProjects_AutomationConditionForm from "./render/automation-condition-form";
import mapProject from "../../../import/normalize/map-project";
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldProjects_FormElement from "./render/form-element";
import FieldProjects_FormElementView from "./render/form-element-view";
import {EntityType} from "../../../../gd/const/item";

// import ParentDropdownAutomation from "./automation/automation"

// Use EntityType!!!
export enum ProjectParentsFor {
    COMMON              = 'common-use',
    TASK                = 'task',
    USER                = 'user',
    REPORT              = 'report',
    DOCUMENT            = 'document',
    EVENT               = 'event',
    DASHBOARD           = 'dashboard',
    DISCUSSION          = 'discussion',
    REQUESTS_AND_FORMS  = 'requests-and-forms'
}

// viewMode possible values: "all", "projects", "companies"
export enum FieldProjects_ViewModes {
    ALL         = 'all',
    PROJECTS    = 'projects',
    COMPANIES   = 'companies'   // I doubt in user
}

export default class FieldProjects extends FieldProto {

    // parentsFor possible values: "common-use", "event", ConstProject.type.PROJECT ,ConstProject.type.WORKFOLDER,
    // ConstProject.type.BACKLOG, ConstProject.type.SPRINT, ConstProject.type.TAG, "task", "user", "report", 'document'
    // public parentsFor       : ProjectParentsFor
    public parentsFor           : EntityType | EntityType[]
    public displayWorkspaceRoot : boolean = false

    // viewMode possible values: "all", "projects", "companies"
    public viewMode             : FieldProjects_ViewModes

    public showProjectIcon      : boolean   // true = display icon
    public showIcon             : boolean   // true = display icon ???

    FIELD_DEFAULT_WIDTH = 200;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "Project selector";
        this.formType               = 'select';

        // isSearchable ?????????
        // this.searchable             = _.get(config,'searchable',true);
        this.isSearchable             = _.get(config,'searchable',true);

        this.noValueOption          = _.get(config,'addNoValueOption',true);
        // patch to support noValueOption key
        if (!_.isNil(config.noValueOption)) this.noValueOption = _.get(config,'noValueOption',true);

        this.noValueOptionIcon      = _.get(config,'noValueOptionIcon',undefined)
        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','None')

        this.placeholder            = _.get(config,'placeholder','Please select');

        this.parentsFor             = _.get(config,'parentsFor', EntityType.PROJECT);
        this.displayWorkspaceRoot   = _.get(config,'displayWorkspaceRoot', false)
        this.viewMode               = _.get(config,'viewMode',FieldProjects_ViewModes.ALL);

        this.showProjectIcon        = _.get(config,'showProjectIcon',true);
        this.showIcon               = _.get(config,'showIcon',true);

        this.popoverPosition        = config.popoverPosition  // Experimental. For fields that use popover

        this.renderComponents.view                      = FieldProjects_View
        this.renderComponents.formElement               = FieldProjects_FormElement
        this.renderComponents.formElementView           = FieldProjects_FormElementView

        this.renderComponents.inlineEditable            = FieldProjects_InlineEditable

        this.renderComponents.automationTriggerForm     = FieldProjects_AutomationTriggerForm
        this.renderComponents.automationConditionForm   = FieldProjects_AutomationConditionForm
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)

        let res: string[] = []
        _.map(rawValue, v=>{
            const project = gd.session.projects.get(rawValue)
            if (project) res.push(project.name)
        })
        return res.join(', ')
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        let selectedValues: string[] = value ? value.split(', ') : []
        selectedValues = _.map(selectedValues, (value: string) => value.toLowerCase())

        const ids: string[] = []
        _.map(selectedValues, (value: string): void => {
            const projectId = mapProject(gd.companyId, value)
            if (projectId) ids.push(projectId)
        })

        return ids
    }
}
